export enum Direction {
    Inbound = 0,
    Outbound = 1,
    UNRECOGNIZED = -1
  }